import React, { createContext, useContext, useState, useCallback } from 'react';

const UnsavedChangesContext = createContext();

export const UnsavedChangesProvider = ({ children }) => {
	const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
	const [onConfirmNavigation, setOnConfirmNavigation] = useState(null);

	const checkUnsavedChanges = useCallback((callback) => {
		if (hasUnsavedChanges && onConfirmNavigation) {
			// Вызываем функцию подтверждения из компонента
			onConfirmNavigation(callback);
			return true; // Есть несохраненные изменения
		}
		return false; // Нет несохраненных изменений
	}, [hasUnsavedChanges, onConfirmNavigation]);

	const registerUnsavedChanges = useCallback((hasChanges, confirmCallback) => {
		setHasUnsavedChanges(hasChanges);
		setOnConfirmNavigation(() => confirmCallback);
	}, []);

	return (
		<UnsavedChangesContext.Provider value={{ hasUnsavedChanges, checkUnsavedChanges, registerUnsavedChanges }}>
			{children}
		</UnsavedChangesContext.Provider>
	);
};

export const useUnsavedChanges = () => {
	const context = useContext(UnsavedChangesContext);
	if (!context) {
		throw new Error('useUnsavedChanges must be used within UnsavedChangesProvider');
	}
	return context;
};
